import { render, staticRenderFns } from "./VPageContentSticky.vue?vue&type=template&id=4057b715&scoped=true&"
import script from "./VPageContentSticky.vue?vue&type=script&lang=ts&"
export * from "./VPageContentSticky.vue?vue&type=script&lang=ts&"
import style0 from "./VPageContentSticky.vue?vue&type=style&index=0&id=4057b715&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4057b715",
  null
  
)

export default component.exports